import React, { Component } from 'react'
import { Card, Dimmer, Loader } from 'semantic-ui-react'

class CardWrapper extends Component {

  render() {
    const { t } = this.props;
    return (
      <Card fluid>
        {this.props.title ?
          (
            <Card.Content>
              <Card.Header>
                <h3>{t(this.props.title)}</h3>
              </Card.Header>
            </Card.Content>
          ) : (
            null
          )
        }
        <Card.Content>
          {this.props.children}
          <Dimmer active={this.props.isLoading} inverted>
            <Loader />
          </Dimmer>
        </Card.Content>
      </Card>
    )
  }
}

export default CardWrapper
